import { ModalButton } from '@components/modalButton/ModalButton';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { ColumnType } from '@inqool/uas-web-core/es/components/controls/Grid/constants';
import { EventsFormDelictsSaveISEPForm } from '@modules/events/EventsFormDelictsSaveISEPForm';
import { delictResolutionEnum, delictStateEnum } from '@modules/events/_eventsEnums';
import { paymentMethod } from '@modules/tickets/_ticketsEnums';
import { get } from 'lodash';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { TextField } from 'material-ui';

export const delictsEventColumns = [
  {
    label: 'Identifikátor v systému ISEP',
    field: 'isepId',
    type: ColumnType.TEXT,
    width: 100
  },
  {
    label: 'Sekvenční číslo',
    field: 'number',
    type: ColumnType.TEXT,
    width: 100
  },
  {
    label: 'Zákon',
    field: 'typeLaw',
    displayField: 'type',
    mapper: o => get(o, 'law'),
    type: ColumnType.TEXT,
    width: 100
  },
  {
    label: 'Novela',
    field: 'typeAmendment',
    displayField: 'type',
    mapper: o => get(o, 'amendment'),
    type: ColumnType.TEXT,
    width: 100
  },
  {
    label: 'Paragraf',
    field: 'typeParagraph',
    displayField: 'type',
    mapper: o => get(o, 'paragraph'),
    type: ColumnType.TEXT,
    width: 100
  },
  {
    label: 'Odstavec',
    field: 'typeSection',
    displayField: 'type',
    mapper: o => get(o, 'section'),
    type: ColumnType.TEXT,
    width: 100
  },
  {
    label: 'Písmeno',
    field: 'typeLetter',
    displayField: 'type',
    mapper: o => get(o, 'letter'),
    type: ColumnType.TEXT,
    width: 100
  },
  {
    label: 'Bod',
    field: 'typePointOfLetter',
    displayField: 'type',
    mapper: o => get(o, 'pointOfLetter'),
    type: ColumnType.TEXT,
    width: 100
  },
  {
    label: 'Vozidlo přestupce',
    field: 'vehicle.name',
    displayField: 'vehicle',
    mapper: o => get(o, 'registrationNumber'),
    type: ColumnType.TEXT,
    width: 100
  },
  {
    label: 'Přestupce',
    field: 'offender.name',
    displayField: 'offender',
    mapper: o => get(o, 'person.fullName'),
    type: ColumnType.TEXT,
    width: 100
  },
  {
    label: 'Úmysl',
    field: 'intention',
    type: ColumnType.BOOLEAN,
    width: 100
  },
  {
    label: 'Datum a čas přestupku',
    field: 'date',
    type: ColumnType.DATETIME,
    width: 100,
    compact: true
  },
  {
    label: 'Datum a čas vyřešení',
    field: 'resolutionDate',
    type: ColumnType.DATETIME,
    width: 100,
    compact: true
  },
  {
    label: 'Datum a čas uzavření',
    field: 'closeDate',
    type: ColumnType.DATETIME,
    width: 100,
    compact: true
  },
  {
    label: 'Datum a čas opisu z ISEP',
    field: 'isepCheckDatetime',
    type: ColumnType.DATETIME,
    width: 100,
    compact: true
  },
  {
    label: 'Datum a čas zápisu ISEP',
    field: 'isepDate',
    type: ColumnType.DATETIME,
    width: 100,
    compact: true
  },
  {
    label: 'Typ přestupku',
    field: 'type.name',
    displayField: 'type',
    mapper: o => get(o, 'name'),
    type: ColumnType.TEXT,
    width: 100
  },
  {
    label: 'Stav',
    field: 'state.id',
    displayField: 'state',
    type: ColumnType.ENUM,
    enum: delictStateEnum,
    width: 100
  },
  {
    label: 'Způsob řešení',
    field: 'resolution.id',
    displayField: 'resolution',
    type: ColumnType.ENUM,
    enum: delictResolutionEnum,
    width: 100
  },
  {
    label: 'Číslo bloku',
    field: 'fineNumber',
    displayField: 'fine',
    mapper: o => get(o, 'fullNumber'),
    type: ColumnType.TEXT,
    width: 100
  },
  {
    label: 'Vyrozumění',
    field: 'noticeOfficer.name',
    displayField: 'noticeOfficer',
    type: ColumnType.TEXT,
    mapper: o => get(o, 'fullName'),
    width: 100
  },
  {
    label: 'Stěračenka',
    field: 'noticeTicketFullNumber',
    displayField: 'noticeTicket',
    type: ColumnType.TEXT,
    mapper: o => get(o, 'fullNumber'),
    width: 100
  },
  {
    label: 'Datum a čas vyrozumění',
    field: 'noticeDate',
    type: ColumnType.DATETIME,
    width: 100,
    compact: true
  },
  {
    label: 'Řešitel',
    field: 'resolutionOfficer.name',
    displayField: 'resolutionOfficer',
    type: ColumnType.TEXT,
    mapper: o => get(o, 'fullName'),
    width: 100
  },
  {
    label: 'Suma',
    field: 'fineValue',
    displayField: 'fine',
    type: ColumnType.TEXT,
    mapper: o => get(o, 'value'),
    width: 100
  },
  {
    label: 'Platební metoda',
    field: 'fine.paymentMethod',
    displayField: 'fine',
    type: ColumnType.TEXT,
    mapper: o => {
      const pm = paymentMethod.find(v => v.id === get(o, 'paymentMethod'));
      return pm ? pm.label : '';
    },
    width: 100
  },
  {
    label: 'Autor',
    field: 'officer.name',
    displayField: 'officer',
    type: ColumnType.TEXT,
    mapper: o => get(o, 'fullName'),
    width: 100
  }
];

export default [
  {
    label: 'Událost',
    field: 'eventNumber',
    displayField: 'event',
    mapper: o => get(o, 'number'),
    type: ColumnType.TEXT,
    width: 100
  },
  {
    label: 'Detail události',
    field: 'eventNumber',
    type: ColumnType.JSX,
    width: 100,
    clickable: false,
    jsx: ({ row }) =>
      get(row, 'event', false) ? (
        <div style={{ padding: 5 }}>
          <Button
            containerElement={<Link to={`/events?item=${get(row, 'event.id')}`} />}
            label={get(row, 'event.number')}
          />
        </div>
      ) : (
        <div />
      )
  },
  {
    label: 'Klasifikace události',
    field: 'eventClassifications',
    type: ColumnType.JSX,
    width: 100,
    clickable: false,
    jsx: ({ row }) => (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', padding: 5 }}>
        {get(row, 'event.classifications', []).map(({ id, name }) => <span key={id}>{name}</span>)}
      </div>
    ),
    filterComponent: ({ onChange, ...props }) => {
      return <TextField onChange={(_e, v) => onChange(v)} {...props} />;
    },
    filterOperations: ['CONTAINS']
  },
  {
    label: 'Zápis ISEP',
    field: 'isepId',
    type: ColumnType.JSX,
    width: 100,
    clickable: false,
    jsx: ({ row, gridProps: { refresh } }) => (
      <div style={{ padding: 5 }}>
        <ModalButton
          label={'ISEP'}
          delictId={get(row, 'id')}
          reloadDelict={refresh}
          ModalComponent={EventsFormDelictsSaveISEPForm}
          style={{ marginBottom: 10, marginRight: 10 }}
          disabled={get(row, 'isepId') || !get(row, 'isepCheckDatetime')}
        />
      </div>
    )
  },
  ...delictsEventColumns,
  {
    label: 'Směna',
    field: 'shiftName',
    displayField: 'event',
    type: ColumnType.TEXT,
    mapper: o => get(o, 'shift.name'),
    width: 100
  },
  {
    label: 'Typ události',
    field: 'eventTypeName',
    displayField: 'event',
    type: ColumnType.TEXT,
    mapper: o => get(o, 'type.name'),
    width: 100
  },
  {
    label: 'Adresa Události',
    field: 'eventAddress',
    displayField: 'event',
    type: ColumnType.TEXT,
    mapper: o => get(o, 'address.fullAddress'),
    width: 100
  }
];



// WEBPACK FOOTER //
// ./src/modules/delicts/_delictsColumns.tsx